query ContentTimecodes($id: ID!) {
  contentTimecodes(id: $id) {
    id
    timecodes {
      id
      type
      time
      title
      description
      icon
      duration
      position
      linkedContent {
        id
        title
        preview {
          id
          url(format: SMALL)
        }
      }
    }
    updatedAt
  }
}
